import { useRecoilState } from "recoil";
import { backendDataAtom } from "recoil/atoms/backendDataAtom.js";
import { backendPost } from "services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useObjectActions() {
  const [backendData, setBackendData] = useRecoilState(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state = backendData?.data ? backendData : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "object-list",
      data: data,
    });
  };

  const createOrUpdateObject = async (form_data, options) => {
    form_data.api_version = "v2";

    await backendPost("data/objekt", {
      label: "Objekt",
      toSend: form_data,
      enqueueSnackbar,
      setResult: (res) => {
        updateListItemState(backendData, setBackendData, res.data);
      },
      ...options
    });
  };

  return {
    createOrUpdateObject,
    setState,
    state,
  };
}
